import GenericContainer from 'components/@container/generic-container';
import { GetServerSideProps, NextPage } from 'next';
import useIsGuest from '../../../hooks/use-is-guest';
import Layout from '../../../components/layout';
import React, { useState } from 'react';
import useCreateBulkRmiRequest, {
  BulkRmiResponse,
} from '../../../hooks/use-create-bulk-rmi-request';
import Spacings from '../../../shared/tds/components/tokens/layout/spacings';
import Spacer from '../../../shared/tds/components/@atoms/spacer';
import Link from 'next/link';
import NewRequestDescription from '../../../components/@account-bulk-rmi-request/new-request-description';
import CreateRequestForm from '../../../components/@account-bulk-rmi-request/create-request-form';

interface Props {
  isGuest: boolean;
}

const BulkRmiRequestNewPage: NextPage<Props> = ({ isGuest }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [response, setResponse] = useState<BulkRmiResponse | null>(null);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const createBulkRmiRequest = useCreateBulkRmiRequest((data) => {
    setLoading(false);
    setErrorMessage('');

    if (data?.createBulkRmiRequest) {
      setResponse(data.createBulkRmiRequest);
      if (
        data.createBulkRmiRequest.statusCode == 200 &&
        data.createBulkRmiRequest.bulkRmiRequest
      ) {
        window.location.href =
          window.location.href = `/account/bulk-rmi-request/${data.createBulkRmiRequest.bulkRmiRequest.id}`;
      }
    }
  });

  return (
    <Layout title="Volvo RMI Licensing Request">
      <GenericContainer
        title="Volvo RMI Licensing Request"
        breadcrumb={{
          url: '/account/bulk-rmi-request',
          text: 'Back to Volvo RMI Licensing requests',
        }}
      >
        <div className="content">
          <NewRequestDescription />
          <Spacer spacing={Spacings.small} orientation="vertical" />
          {isGuest ? (
            <Link href="/account/signin">
              <a data-cy="sign-in-link">Sign in to create a new request</a>
            </Link>
          ) : (
            <CreateRequestForm
              submit={createBulkRmiRequest}
              submitLoading={loading}
              submitErrorMessage={errorMessage}
              submitResponse={response}
            />
          )}
        </div>
      </GenericContainer>
    </Layout>
  );
};

/* eslint-disable react-hooks/rules-of-hooks */
export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  const isGuest = await useIsGuest(req);
  /* eslint-enable react-hooks/rules-of-hooks */

  return {
    props: { isGuest: isGuest },
  };
};

export default BulkRmiRequestNewPage;
